var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_teacher",
    "data-name": "vuesax/bold/teacher",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.173,
    height: 20.173,
    viewBox: "0 0 20.173 20.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.423.144a.84.84,0,0,1,1.3.706V1.934A2.881,2.881,0,0,1,8.893,4.481l-2.681.891a3.068,3.068,0,0,1-1.7,0L1.832,4.481A2.867,2.867,0,0,1,0,1.934V.842A.84.84,0,0,1,1.294.136L3.026,1.262a4.242,4.242,0,0,0,2.345.664,4.242,4.242,0,0,0,2.345-.664Z",
    transform: "translate(4.724 13.002)",
    fill: "#5a607f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.624,3.751,9.589.448a3.287,3.287,0,0,0-3.312,0l-5.06,3.3a2.678,2.678,0,0,0,0,4.489l1.345.874,3.715,2.421a3.287,3.287,0,0,0,3.312,0l3.69-2.421,1.152-.757v2.572a.63.63,0,0,0,1.261,0V6.794A2.669,2.669,0,0,0,14.624,3.751Z",
    transform: "translate(2.171 1.679)",
    fill: "#5a607f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H20.173V20.173H0Z",
    transform: "translate(20.173 20.173) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.6e8d4ad63d6709de2a3dad2262578942.svg";
export { ForwardRef as ReactComponent };